module.exports = __webpack_public_path__ + "static/media/gold.9b34c9d5.jpg";